import { TopupRequestDTO } from '../../../../../card/src/domain/Card/entities/TopupCard/TopupRequestDTO';
import { Account } from '../entities';

type FormData = {
  amount?: string;
  account?: Account;
  code?: string;
  currency?: string;
};

const topupAccountFormDataToRequestDTOAdapter = (formData?: FormData): TopupRequestDTO => {
  const data = {
    ...formData,
  };
  return new TopupRequestDTO(data);
};

export { topupAccountFormDataToRequestDTOAdapter };
